export const orderService = {
  title: 'Untitled',
  category: null,
  itemSource: '',
  notes: null,
  includeInInvoice: true,
  authorized: false,
  tech: null,
  status: 'new',
  serviceStatus: 'pending',
  billableHours: 0,
  workedHours: 0,
  items: [],
  serviceTotal: {
    part: 0,
    labor: 0,
    other: 0,
    total: 0,
    itemsDiscount: 0,
    afterDiscountTotal: 0,
  },
  totalCost: {
    part: 0,
    labor: 0,
    tire: 0,
    other: 0,
  },
};
